import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useShokurekishoFormatData } from '@/composables/format-edit/useShokurekishoFormatData'

type ShokurekishoTextareaField = 'skills' | 'intelligence' | 'otherskills'

type Autosize = boolean | { minRows?: number; maxRows?: number }


export default /*#__PURE__*/_defineComponent({
  __name: 'ShokurekishoTextareaCard',
  props: {
    currentCardId: null,
    cardId: null,
    title: null,
    lead: null,
    field: null,
    autosize: { type: [Boolean, Object], default: () => ({ minRows: 3, maxRows: 5 }) },
    inputTitle: { default: '' }
  },
  setup(__props: any) {

const props = __props as { currentCardId?: string, cardId: string, title: string, lead: string, field: ShokurekishoTextareaField, autosize: Autosize, inputTitle: string };



const formatData = useShokurekishoFormatData()

const fieldValue = computed({
  get() {
    const value = formatData[props.field]
    return typeof value === 'string' ? value : ''
  },
  set(next: string) {
    formatData[props.field] = next
  }
})

return { __sfc: true,props, formatData, fieldValue }
}

})